import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)


//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};


export default new Router({
  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return saveTop;
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'layout',
      component: () => import('../views/main'),
      redirect: '/index',
      children: [
        {
          path: '/index',
          name: 'index',
          meta: { title: '主页', layout: 'index' },
          component: () => import('../views/index')
        },
        {
          path: '/sreach',
          name: 'sreach',
          meta: { title: '搜索页', layout: 'index' },
          component: () => import('../views/sreach')
        },
        {
          path: '/menu',
          name: 'menu',
          meta: { title: '菜单页', layout: 'index' },
          component: () => import('../views/menu')
        },
        {
          path: '/cultivate',
          name: 'cultivate',
          meta: { title: '培训页', layout: 'index' },
          component: () => import('../views/cultivate')
        },
        {
          path: '/itService',
          name: 'itService',
          meta: { title: 'it咨询', layout: 'index' },
          component: () => import('../views/itService')
        },
        {
          path: '/capital',
          name: 'capital',
          meta: { title: '金合资本页', layout: 'index' },
          component: () => import('../views/capital')
        },
        {
          path: '/listed',
          name: 'listed',
          meta: { title: '上市助推', layout: 'index' },
          component: () => import('../views/listed')
        },
        {
          path: '/team',
          name: 'team',
          component: () => import('../views/main'),
          redirect: '/team/index',
          children: [
            {
              path: 'index',
              name: 'team',
              meta: { title: '专家团', layout: 'index' },
              component: () => import('../views/team')
            },
            {
              path: 'detail',
              name: 'team',
              meta: { title: '专家详情团', layout: 'index' },
              component: () => import('../views/teamdetail')
            }
          ]
        },
        {
          path: '/server',
          name: 'server',
          component: () => import('../views/main'),
          redirect: '/server/index',
          children: [
            {
              path: 'index',
              name: 'server',
              meta: { title: '咨询页', layout: 'index' },
              component: () => import('../views/server')
            },
            {
              path: 'detail',
              name: 'server',
              meta: { title: '咨询页', layout: 'index' },
              component: () => import('../views/servedetail')
            }
          ]
        }

      ]
    },
    {
      path: '/index',
      name: 'index',
      meta: { title: '主页', layout: 'index' },
      component: () => import('../views/index')
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      meta: { title: '关于我们' },
      component: () => import('../views/aboutUS/index'),
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      meta: { title: '新闻详情' },
      component: () => import('../views/newsDetail/index.vue'),
    },
    {
      path: '/recruit',
      name: 'recruit',
      meta: { title: '人才招聘' },
      component: () => import('../views/recruit/index.vue'),
    },
    {
      path: '/recruitDetail',
      name: 'recruitDetail',
      meta: { title: '岗位详情' },
      component: () => import('../views/recruitDetail/index.vue'),
    },
    {
      path: '/business',
      name: 'business',
      meta: { title: '商务合作' },
      component: () => import('../views/business/index.vue'),
    },
    {
      path: '/case',
      name: 'case',
      meta: { title: '客户案例' },
      component: () => import('../views/case/index.vue'),
    },
    {
      path: '/caseDetail',
      name: 'caseDetail',
      meta: { title: '客户案例详情' },
      component: () => import('../views/caseDetail/index.vue'),
    },
     {
      path: '/test',
      name: 'test',
      meta: { title: '客户案例详情' },
      component: () => import('../views/test/index.vue'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js